import {getCookie} from '../../../../common/utils'

export const PammRedirect = () => {
  const pammCookie = getCookie('pammOffer')

  if (pammCookie && !window.location.pathname.startsWith('/pamm-offer')) {
    try {
      const pammOffer = JSON.parse(decodeURIComponent(pammCookie))
      if (pammOffer?.pammManagerId && pammOffer?.pammOfferId) {
        window.location.href = `/pamm-offer/${pammOffer.pammManagerId}/${pammOffer.pammOfferId}`
      }
    } catch {
      // ignore malformed cookie
    }
  }
  return null
}
